<template v-if="childDataLoaded">
    <div id="cep">
        <vs-input class="w-full" label="CEP" v-mask="'#####-###'" v-model="cep" @keyup="changedValue()" :disabled="disabled"></vs-input>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    directives : { mask },

    props : {
        number : {
            required : false
        },
        disabled: Boolean
    },
    
    data () {
        return {
            cep : ''
        }
    },

    mounted () {
        this.cep = this.number
        // this.$message.config({ top: '80px'})
    },

    methods : {
        async changedValue() {
            let cep = this.cep.replace('-', '')

            if(cep.length == 8) {
                try {
                    this.$vs.loading({
                        container : '#cep',
                        scale: 0.8
                    })

                    this.$emit('fetching', true);

                    let addressFields = await this.$http.get(`https://viacep.com.br/ws/${cep}/json/`)
                    if(addressFields.data.hasOwnProperty('erro')) throw new Error('CEP não encontrado');
                    
                    this.$emit('fetched', addressFields)
                } catch (err) {
                    this.$message.error(`Erro ao encontrar CEP informado: ${err.message}`, 5)
                } finally {
                    this.$emit('fetching', false);
                    this.$vs.loading.close('#cep > .con-vs-loading')
                }
                
            }
        }
    }
}

</script>
